import React from "react";
import { makeStyles } from "@mui/styles";
import yellow from "../../../assets/Images/yellow.mp4";


const customStyles = makeStyles({
root: {
  marginTop: "100px",
  padding: "150px 0px",
  fontFamily: "Montserrat",
  position: "relative", // Add this
  overflow: "hidden",   // Optional, for clipping the video
  zIndex: 1,
},
videoBG: {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "100%",
  height: "100%",
  objectFit: "cover",
  zIndex: -1,
  pointerEvents: "none",
},


  aboutWrapper: {
    width: "90%",
    maxWidth: "1216px",
    display: "flex",
    marginRight: "auto",
    marginLeft: "auto",
  },
  leftSide: {
    minWidth: "58%",
    display: "flex",
    flexDirection: "column",
  },
  aboutHeader: {
    fontSize: "18px",
        color: "black",
    fontWeight: "600",
    display: "flex",
    justifyContent: "space-between",
    fontFamily: "Montserrat",
  },
  storeHeader: {
    marginTop: "20px",
    color: "black",
    fontSize: "48px",
    lineHeight: "1.3em",
     fontFamily: "Montserrat",
  },
  leftDetails: {
    marginTop: "75px",
    color: "black",
    fontWeight: "600",
    fontSize: "18px",
 fontFamily: "Montserrat",
  },
  righDetails: {
    maxWidth: "40%",
    marginTop: "55px",
    fontWeight: "600",
    fontSize: "18px",
    color: "black",
 fontFamily: "Montserrat",
  },
   // Media Query for Extra Small Screens (<320px)
   '@media (max-width: 319px)': {
    root: {
      padding: "40px 10px",
      marginTop: "80px",
      fontFamily: "Montserrat",
    },
    aboutWrapper: {
      flexDirection: "column",
    },
    leftSide: {
      minWidth: "100%",
      marginBottom: "20px",
      fontFamily: "Montserrat",
    },
    aboutHeader: {
      fontSize: "14px",
      fontFamily: "Montserrat",
    },
    storeHeader: {
      fontSize: "28px",
      lineHeight: "1.1em",
      fontFamily: "Montserrat",
    },
    leftDetails: {
      marginTop: "20px",
      fontSize: "14px",
      fontFamily: "Montserrat",
    },
    righDetails: {
      maxWidth: "100%",
      fontSize: "14px",
      fontFamily: "Montserrat",
    },
  },

  // Media Query for Small Screens (320px - 480px)
  '@media (min-width: 320px) and (max-width: 480px)': {
    root: {
      padding: "50px 10px",
      marginTop: "100px",
      fontFamily: "Montserrat",
    },
    aboutWrapper: {
      flexDirection: "column",
      fontFamily: "Montserrat",
    },
    leftSide: {
      minWidth: "100%",
      marginBottom: "20px",
      fontFamily: "Montserrat",
    },
    aboutHeader: {
      fontSize: "16px",
      fontFamily: "Montserrat",
    },
    storeHeader: {
      fontSize: "32px",
      lineHeight: "1.2em",
      fontFamily: "Montserrat",
    },
    leftDetails: {
      marginTop: "30px",
      fontSize: "16px",
      fontFamily: "Montserrat",
    },
    righDetails: {
      maxWidth: "100%",
      fontSize: "16px",
      fontFamily: "Montserrat",
    },
  },

  // Media Query for Medium Screens (481px - 768px)
  '@media (min-width: 481px) and (max-width: 768px)': {
    root: {
      padding: "100px 20px",
      marginTop: "120px",
      fontFamily: "Montserrat",
    },
    aboutWrapper: {
      flexDirection: "row",
      fontFamily: "Montserrat",
    },
    leftSide: {
      minWidth: "55%",
      marginBottom: "30px",
      fontFamily: "Montserrat",
    },
    aboutHeader: {
      fontSize: "17px",
      fontFamily: "Montserrat",
    },
    storeHeader: {
      fontSize: "40px",
      lineHeight: "1.25em",
      fontFamily: "Montserrat",
    },
    leftDetails: {
      marginTop: "50px",
      fontSize: "17px",
      fontFamily: "Montserrat",
    },
    righDetails: {
      maxWidth: "45%",
      fontSize: "17px",
      fontFamily: "Montserrat",
    },
  },

  // Media Query for Large Screens (769px - 1024px)
  '@media (min-width: 769px) and (max-width: 1024px)': {
    root: {
      padding: "120px 30px",
      marginTop: "140px",
      fontFamily: "Montserrat",
    },
    aboutWrapper: {
      flexDirection: "row",
      fontFamily: "Montserrat",
    },
    leftSide: {
      minWidth: "60%",
      fontFamily: "Montserrat",
    },
    aboutHeader: {
      fontSize: "18px",
    },
    storeHeader: {
      fontSize: "46px",
      lineHeight: "1.3em",
      fontFamily: "Montserrat",
    },
    leftDetails: {
      marginTop: "60px",
      fontSize: "18px",
      fontFamily: "Montserrat",
    },
    righDetails: {
      maxWidth: "40%",
      fontSize: "18px",
      fontFamily: "Montserrat",
    },
  },
});

const About = () => {
  const classes = customStyles();

  return (
    <div className={classes.root}>
      {/* 🎥 Background video */}
      <video autoPlay loop muted playsInline className={classes.videoBG}>
        <source src={yellow} type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      <div className={classes.aboutWrapper}>
        <div className={classes.leftSide}>
          <div className={classes.aboutHeader}></div>
          <div className={classes.storeHeader}>
            A smart self-service store for your community
          </div>
          <div className={classes.leftDetails}>
            Simple and secure access:
            <ul>
              <li>Enter your <strong>phone number</strong> and <strong>ALPIN</strong></li>
              <li>The machine unlocks — pick your snack </li>
              <li>We capture the entry and exit automatically</li>
            </ul>
            Done in under 10 seconds — no queues, no cash, no staff.
          </div>
        </div>

        <div className={classes.righDetails}>
          <br />• Fresh snacks restocked <strong className="text-decoration-underline">almost daily</strong>
          <br />• Available 24×7 — <strong className="text-decoration-underline">anytime access</strong>
          <br />• App-connected and fully digital experience
          <br />• Automatic billing through <u><b>AlpaaGo Wallet</b></u>
          <br />• Designed for all types of communities and shared spaces
        </div>
      </div>
    </div>
  );
};


export default About;
